import { useEffect } from "react";

import Grid from "@mui/material/Grid";
import Autocomplete from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";
import Stack from "@mui/material/Stack";
import { LocalizationProvider, DatePicker } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { fr } from "date-fns/locale";
import moment from "moment";

// Material Dashboard 2 PRO React components
import MDBox from "../../../components/MDBox";
import MDInput from "../../../components/MDInput";

import { useSelector, useDispatch } from "react-redux";

import { getUsers } from "api/users";

import { setAllUsers } from "redux/reducers/usersReducer";
import Tooltip from "@mui/material/Tooltip";

import { deviceStatusAdminEnum, deviceStatusRandomEnum } from "../../../config/enum";

export default function PreparationFirst({
  user,
  deviceId,
  status,
  setStatus,
  madContractualDate,
  setMadContractualDate,
  assemblyStartContractualDate,
  setAssemblyStartContractualDate,
  madProvisionalDate,
  setMadProvisionalDate,
  assemblyStartProvisionalDate,
  setAssemblyStartProvisionalDate,
  edit,
}) {
  const dispatch = useDispatch();
  const allUsers = useSelector((state) => state.users.allUsers);

  async function fetchUsers() {
    const response = await getUsers();
    const formatedUsers = await response.data.map((user) => ({
      label: user.name,
      id: user.user_id,
    }));
    dispatch(setAllUsers(formatedUsers));
  }

  useEffect(() => {
    fetchUsers();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <MDBox>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Autocomplete
            options={
              user && user.role !== "Admin" && user.role !== "Pilote"
                ? deviceStatusRandomEnum
                : deviceStatusAdminEnum
            }
            value={status}
            onChange={(event, newStatus) => {
              setStatus(newStatus);
            }}
            renderInput={(params) => (
              <MDInput {...params} label="Statut de l'appareil" variant="standard" />
            )}
          />
        </Grid>
        <Grid item container xs={12} spacing={2}>
          <Grid item xs={6} display="block" alignItems="center">
            <Tooltip
              title={
                user &&
                user.role !== "Admin" &&
                user.role !== "Pilote" &&
                user.role !== "Contremaître" &&
                assemblyStartContractualDate !== null
                  ? "Votre rôle ne vous permet pas de modifier cette date"
                  : ""
              }
              placement="top"
            >
              <Stack component="form" noValidate>
                <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={fr}>
                  <DatePicker
                    slotProps={{ field: { clearable: true } }}
                    displayWeekNumber
                    label="Date contractuelle de début de montage"
                    value={assemblyStartContractualDate && new Date(assemblyStartContractualDate)}
                    onChange={(newValue) => {
                      if (newValue === null) {
                        setAssemblyStartContractualDate(null);
                      } else setAssemblyStartContractualDate(moment(newValue).format("YYYY-MM-DD"));
                    }}
                    renderInput={(params) => <TextField {...params} fullWidth />}
                    format="dd/MM/yyyy"
                    disabled={
                      user &&
                      user.role !== "Admin" &&
                      user.role !== "Pilote" &&
                      user.role !== "Contremaître" &&
                      assemblyStartContractualDate !== null
                        ? true
                        : false
                    }
                  />
                </LocalizationProvider>
              </Stack>
            </Tooltip>
          </Grid>
          <Grid item xs={6} display="block" alignItems="center">
            <Tooltip
              title={
                user &&
                user.role !== "Admin" &&
                user.role !== "Pilote" &&
                user.role !== "Contremaître" &&
                madContractualDate !== null
                  ? "Votre rôle ne vous permet pas de modifier cette date"
                  : ""
              }
              placement="top"
            >
              <Stack component="form" noValidate>
                <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={fr}>
                  <DatePicker
                    slotProps={{ field: { clearable: true } }}
                    displayWeekNumber
                    label="Date contractuelle de mise à disposition"
                    value={madContractualDate && new Date(madContractualDate)}
                    onChange={(newValue) => {
                      if (newValue === null) {
                        setMadContractualDate(null);
                      } else setMadContractualDate(moment(newValue).format("YYYY-MM-DD"));
                    }}
                    renderInput={(params) => <TextField {...params} fullWidth />}
                    format="dd/MM/yyyy"
                    disabled={
                      user &&
                      user.role !== "Admin" &&
                      user.role !== "Pilote" &&
                      user.role !== "Contremaître" &&
                      madContractualDate !== null
                        ? true
                        : false
                    }
                  />
                </LocalizationProvider>
              </Stack>
            </Tooltip>
          </Grid>
        </Grid>
      </Grid>
    </MDBox>
  );
}
